export default __webpack_public_path__ + "static/media/germany.8b1001bd.svg";